{
  "fr": {
    "login": {
      "acceptTosPrefix": "J'accepte les ",
      "acceptTos": "conditions générales",
      "acceptTosRequired": "Vous devez accepter les conditions générales pour créer un compte.",
      "auth/invalid-credential": "Le mot de passe est invalide pour l'email donné, ou aucun compte n'existe pour cet email.",
      "auth/too-many-requests": "Trop de demandes, veuillez réessayer plus tard.",
      "auth/invalid-action-code": "Pour des raisons de sécurité, les liens de réinitialisation de mot de passe expirent après un certain temps. Si vous avez encore besoin de réinitialiser votre mot de passe, vous pouvez demander un nouvel email de réinitialisation.",
      "auth-ziggu/invalid-invitation-code": "Veuillez vérifier auprès de la personne qui l'a partagé avec vous s'il y a un nouveau lien disponible. Si vous avez déjà un compte, veuillez vous connecter à la place.",
      "auth-ziggu/user-created": "Votre compte utilisateur a été créé ! 🎉 Nous vous connectons maintenant, patientez..",
      "title_login": "Bon retour !",
      "title_password_forgot": "Mot de passe oublié ?",
      "title_password_reset": "Réinitialisez votre mot de passe",
      "title_expired_reset": "Oups, c'est un lien expiré..",
      "title_expired_signup": "Ce lien d'invitation n'est plus actif",
      "title_signup": "Complétez votre inscription",
      "backToLogin": "Retour à la connexion",
      "cookiePolicy": "Politique de cookies",
      "privacyPolicy": "Politique de confidentialité",
      "googleLogin": "Se connecter avec Google",
      "emailAddress": "Adresse e-mail",
      "emailAddressRequired": "L'adresse e-mail est requise",
      "notification_error_session_expired": "Votre session a expiré, veuillez vous reconnecter.",
      "notification_error_no_access": "Votre compte n'a pas accès.",
      "notification_success_logout": "Vous vous êtes déconnecté de votre compte.",
      "password": "Mot de passe",
      "password_confirm": "Confirmation du mot de passe",
      "passwordForgot": "Mot de passe oublié ?",
      "passwordRequired": "Le mot de passe est requis",
      "passwordLengthRequired": "Le mot de passe doit contenir au moins 8 caractères",
      "passwordConfirmRequired": "La confirmation du mot de passe est requise",
      "passwordConfirmMatchRequired": "La confirmation du mot de passe ne correspond pas",
      "success_password_forgot": "Si vous avez un compte actif, un email de réinitialisation de mot de passe a été envoyé à {email}. Veuillez vérifier votre boîte de réception, le lien de réinitialisation du mot de passe expire dans 1 heure.",
      "success_password_reset": "Réinitialisation du mot de passe réussie, connexion en cours...",
      "submit_login": "Se connecter",
      "submit_password_forgot": "Demander la réinitialisation du mot de passe",
      "submit_password_reset": "Réinitialiser le mot de passe",
      "submit_expired_reset": "Demander une nouvelle réinitialisation de mot de passe",
      "submit_expired_signup": "Retour à la connexion",
      "submit_signup": "Créer un compte",
      "termsandconditionsPolicy": "Conditions générales"
    }
  }
}
